<template>
  <Modal
    class="re-login__modal"
    id="re-login-modal"
    header-tag="h1"
    :reset-listener="resetListener"
    :show="show"
  >
    <template #header>
      {{ translate('Please re-enter your password', $options.name) }}
    </template>
    <!-- replace close with non-interactive modal to fix keyboard trap -->
    <template #close><span></span></template>
    <div class="re-login__content" id="">
      <p class="re-login__sub-title">
        {{
          translate(
            'Your session expired. Please re-authenticate to access your account again.',
            $options.name,
          )
        }}
      </p>
      <Login ref="loginForm" class="re-login__form" @authenticated="authenticated" @error="error">
        <template #default="{ email: scopedEmail, password, update }">
          <label for="email" class="re-login__form-label">
            <div class="re-login__form-input-wrapper">
              <EmailIcon class="re-login__form-icon" />
              <input
                aria-label="email"
                id="re-login__email"
                type="text"
                :value="scopedEmail"
                disabled
              />
            </div>
          </label>
          <label for="password" class="re-login__form-label">
            <div class="re-login__form-input-wrapper">
              <PasswordIcon class="re-login__form-icon" />
              <input
                aria-label="password"
                id="re-login__password"
                @input="update('password', $event.target.value)"
                type="password"
                :value="password"
              />
            </div>
          </label>
        </template>
      </Login>
      <div class="re-login__redirect-login">
        {{ translate('Not your account?', $options.name) }}
        <a href="#" @click.prevent="goToLogin">
          {{ translate('Login', $options.name) }}
        </a>
        {{ translate('here', $options.name) }}
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from '@/components/UI/Modal.vue';

// Components
import { Login } from '@/pigeonline/wrapper';

// Icons
import EmailIcon from '@/assets/icons/Login/email.svg';
import PasswordIcon from '@/assets/icons/Login/pswd.svg';

export default {
  name: 'ReLoginModal',
  components: {
    Modal,
    Login,
    EmailIcon,
    PasswordIcon,
  },
  props: {
    email: {
      type: String,
      default: () => '',
    },
    show: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      resetListener: false,
    };
  },
  mounted() {
    this.$refs.loginForm.update('email', this.email);
    document.body.appendChild(this.$el);
    setTimeout(() => {
      this.resetListener = !this.resetListener;
      document.getElementById('re-login-modal').querySelector('div.modal-container').focus();
    }, 1000);
  },
  methods: {
    error: function () {
      this.$emit('error');
    },
    authenticated: function () {
      this.$emit('authenticated');
    },
    goToLogin: function () {
      this.$emit('goToLogin');
    },
  },
};
</script>
